var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ff4116",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,19v-14c0,-1.657 1.343,-3 3,-3h7l6,6v11c0,1.657 -1.343,3 -3,3h-10c-1.657,0 -3,-1.343 -3,-3z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,6v-4l6,6h-4c-1.105,0 -2,-0.895 -2,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.703,13.881c0,1.638 -1.325,1.932 -1.788,1.932h-0.584v1.521c0,0.368 -0.298,0.666 -0.666,0.666v0c-0.367,0 -0.665,-0.298 -0.665,-0.665v-4.543c0,-0.438 0.354,-0.792 0.791,-0.792h1.073c0.45,0 1.839,0.17 1.839,1.881zM8.432,13.907c0,-0.679 -0.483,-0.763 -0.67,-0.763h-0.431v1.568h0.432c0.186,0 0.669,-0.127 0.669,-0.805z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.596,15.017c0,2.273 -1.216,2.983 -2.492,2.983h-0.895c-0.437,0 -0.791,-0.354 -0.791,-0.791v-4.417c0,-0.437 0.354,-0.791 0.791,-0.791h0.895c1.323,-0.001 2.492,0.744 2.492,3.016zM13.231,15.017c0,-1.587 -0.783,-1.831 -1.11,-1.831h-0.331v3.626h0.331c0.327,0.001 1.11,-0.207 1.11,-1.795z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.738,13.221v1.228h0.872c0.309,0 0.559,0.25 0.559,0.559v0.042c0,0.309 -0.25,0.559 -0.559,0.559h-0.864v1.704c0,0.379 -0.307,0.686 -0.686,0.686v0c-0.379,0 -0.686,-0.307 -0.686,-0.686v-4.522c0,-0.437 0.354,-0.791 0.791,-0.791h1.535c0.33,0 0.598,0.268 0.598,0.598v0.026c0,0.33 -0.268,0.598 -0.598,0.598h-0.962z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/PdfFile.fda34d6187bec8778127f2484546ccdb.svg";
export { ForwardRef as ReactComponent };